/* Lunita Glow · sugerencia de idioma (v2, 4 oct 2026). Reemplaza la ventana «Dos puertas».
   La página ya llega en su idioma (inglés en «/», español en «/es/»). Si el idioma del navegador es el otro,
   arriba sale una barra pequeña que lo sugiere, escrita en ese otro idioma. No tapa nada y se cierra con ×.
   Si la persona ya eligió un idioma (botones ES/EN) o cerró la barra, no vuelve a salir. */
(function () {
  const leer = k => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const guardar = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };
  document.addEventListener("click", e => { if (e.target.closest && e.target.closest(".idioma button")) guardar("lunita-idioma-ok", "1"); }, true);

  const TXT = {
    es: { t: "¿Prefieres ver la página en español?", b: "Ver en español", x: "Cerrar" },
    en: { t: "Prefer to see this page in English?", b: "View in English", x: "Close" }
  };
  function mostrar() {
    if (leer("lunita-idioma-ok") || leer("lunita-idioma-pref") || leer("lunita-sugerencia-no")) return;
    const pagina = document.documentElement.lang === "es" ? "es" : "en";
    const nav = (navigator.languages && navigator.languages[0] || navigator.language || "").toLowerCase().slice(0, 2);
    if (!TXT[nav] || nav === pagina) return;
    const t = TXT[nav];
    const css = `.lsug{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:8px 14px;padding:6px 52px 6px 16px;position:relative;
      background:#FBF7EF;color:#16213F;border-bottom:1px solid rgba(22,33,63,.12);font:400 15px/1.4 "Jost","Avenir Next",sans-serif}
      .lsug button{font:inherit;cursor:pointer;min-height:44px}
      .lsug .lsug-ir{background:none;border:0;padding:0 4px;color:#9A6B2C;text-decoration:underline;text-underline-offset:3px;font-weight:500}
      .lsug .lsug-x{position:absolute;right:4px;top:50%;transform:translateY(-50%);width:44px;background:none;border:0;color:#4A5068;font-size:22px;line-height:1}`;
    const st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);
    const bar = document.createElement("div");
    bar.className = "lsug"; bar.setAttribute("role", "region"); bar.setAttribute("aria-label", t.t); bar.lang = nav;
    bar.innerHTML = `<span>${t.t}</span><button type="button" class="lsug-ir">${t.b}</button><button type="button" class="lsug-x" aria-label="${t.x}">×</button>`;
    bar.querySelector(".lsug-ir").addEventListener("click", () => {
      const b = document.querySelector(`.idioma button[data-l="${nav}"]`);
      bar.remove(); if (b) b.click();
    });
    bar.querySelector(".lsug-x").addEventListener("click", () => { guardar("lunita-sugerencia-no", "1"); bar.remove(); });
    document.body.prepend(bar);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mostrar); else mostrar();
})();
